import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderModule, TranslateModule } from '@xref/ngx';

import { EmailValidatorModule } from '../../components/email-validator/email-validator.module';
import { RequiredValidatorModule } from '../../components/required-validator/required-validator.module';
import { TwoFactorService } from '../../services/two-factor/two-factor.service';
import { TwoFactorSetupModule } from './components/two-factor-setup/two-factor-setup.module';
import { TwoFactorVerificationModule } from './components/two-factor-verification/two-factor-verification.module';
import { TwoFactorComponent } from './two-factor.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RequiredValidatorModule,
        RouterModule,
        EmailValidatorModule,
        TranslateModule,
        LoaderModule,
        TwoFactorVerificationModule,
        TwoFactorSetupModule
    ],
    declarations: [
        TwoFactorComponent
    ],
    providers: [
        TwoFactorService
    ]
})
export class TwoFactorModule {}
